export const timeOptionStart = [
  { value: '12:00 AM', text: '12:00 AM' },
  { value: '12:15 AM', text: '12:15 AM' },
  { value: '12:30 AM', text: '12:30 AM' },
  { value: '12:45 AM', text: '12:45 AM' },
  { value: '01:00 AM', text: '01:00 AM' },
  { value: '01:15 AM', text: '01:15 AM' },
  { value: '01:30 AM', text: '01:30 AM' },
  { value: '01:45 AM', text: '01:45 AM' },
  { value: '02:00 AM', text: '02:00 AM' },
  { value: '02:15 AM', text: '02:15 AM' },
  { value: '02:30 AM', text: '02:30 AM' },
  { value: '02:45 AM', text: '02:45 AM' },
  { value: '03:00 AM', text: '03:00 AM' },
  { value: '03:15 AM', text: '03:15 AM' },
  { value: '03:30 AM', text: '03:30 AM' },
  { value: '03:45 AM', text: '03:45 AM' },
  { value: '04:00 AM', text: '04:00 AM' },
  { value: '04:15 AM', text: '04:15 AM' },
  { value: '04:30 AM', text: '04:30 AM' },
  { value: '04:45 AM', text: '04:45 AM' },
  { value: '05:00 AM', text: '05:00 AM' },
  { value: '05:15 AM', text: '05:15 AM' },
  { value: '05:30 AM', text: '05:30 AM' },
  { value: '05:45 AM', text: '05:45 AM' },
  { value: '06:00 AM', text: '06:00 AM' },
  { value: '06:15 AM', text: '06:15 AM' },
  { value: '06:30 AM', text: '06:30 AM' },
  { value: '06:45 AM', text: '06:45 AM' },
  { value: '07:00 AM', text: '07:00 AM' },
  { value: '07:15 AM', text: '07:15 AM' },
  { value: '07:30 AM', text: '07:30 AM' },
  { value: '07:45 AM', text: '07:45 AM' },
  { value: '08:00 AM', text: '08:00 AM' },
  { value: '08:15 AM', text: '08:15 AM' },
  { value: '08:30 AM', text: '08:30 AM' },
  { value: '08:45 AM', text: '08:45 AM' },
  { value: '09:00 AM', text: '09:00 AM' },
  { value: '09:15 AM', text: '09:15 AM' },
  { value: '09:30 AM', text: '09:30 AM' },
  { value: '09:45 AM', text: '09:45 AM' },
  { value: '10:00 AM', text: '10:00 AM' },
  { value: '10:15 AM', text: '10:15 AM' },
  { value: '10:30 AM', text: '10:30 AM' },
  { value: '10:45 AM', text: '10:45 AM' },
  { value: '11:00 AM', text: '11:00 AM' },
  { value: '11:15 AM', text: '11:15 AM' },
  { value: '11:30 AM', text: '11:30 AM' },
  { value: '11:45 AM', text: '11:45 AM' },
  { value: '12:00 PM', text: '12:00 PM' },
  { value: '12:15 PM', text: '12:15 PM' },
  { value: '12:30 PM', text: '12:30 PM' },
  { value: '12:45 PM', text: '12:45 PM' },
  { value: '01:00 PM', text: '01:00 PM' },
  { value: '01:15 PM', text: '01:15 PM' },
  { value: '01:30 PM', text: '01:30 PM' },
  { value: '01:45 PM', text: '01:45 PM' },
  { value: '02:00 PM', text: '02:00 PM' },
  { value: '02:15 PM', text: '02:15 PM' },
  { value: '02:30 PM', text: '02:30 PM' },
  { value: '02:45 PM', text: '02:45 PM' },
  { value: '03:00 PM', text: '03:00 PM' },
  { value: '03:15 PM', text: '03:15 PM' },
  { value: '03:30 PM', text: '03:30 PM' },
  { value: '03:45 PM', text: '03:45 PM' },
  { value: '04:00 PM', text: '04:00 PM' },
  { value: '04:15 PM', text: '04:15 PM' },
  { value: '04:30 PM', text: '04:30 PM' },
  { value: '04:45 PM', text: '04:45 PM' },
  { value: '05:00 PM', text: '05:00 PM' },
  { value: '05:15 PM', text: '05:15 PM' },
  { value: '05:30 PM', text: '05:30 PM' },
  { value: '05:45 PM', text: '05:45 PM' },
  { value: '06:00 PM', text: '06:00 PM' },
  { value: '06:15 PM', text: '06:15 PM' },
  { value: '06:30 PM', text: '06:30 PM' },
  { value: '06:45 PM', text: '06:45 PM' },
  { value: '07:00 PM', text: '07:00 PM' },
  { value: '07:15 PM', text: '07:15 PM' },
  { value: '07:30 PM', text: '07:30 PM' },
  { value: '07:45 PM', text: '07:45 PM' },
  { value: '08:00 PM', text: '08:00 PM' },
  { value: '08:15 PM', text: '08:15 PM' },
  { value: '08:30 PM', text: '08:30 PM' },
  { value: '08:45 PM', text: '08:45 PM' },
  { value: '09:00 PM', text: '09:00 PM' },
  { value: '09:15 PM', text: '09:15 PM' },
  { value: '09:30 PM', text: '09:30 PM' },
  { value: '09:45 PM', text: '09:45 PM' },
  { value: '10:00 PM', text: '10:00 PM' },
  { value: '10:15 PM', text: '10:15 PM' },
  { value: '10:30 PM', text: '10:30 PM' },
  { value: '10:45 PM', text: '10:45 PM' },
  { value: '11:00 PM', text: '11:00 PM' },
  { value: '11:15 PM', text: '11:15 PM' },
  { value: '11:30 PM', text: '11:30 PM' },
  { value: '11:45 PM', text: '11:45 PM' },
];

export const timeOptionEnd = [
  { value: '12:15 AM', text: '12:15 AM' },
  { value: '12:30 AM', text: '12:30 AM' },
  { value: '12:45 AM', text: '12:45 AM' },
  { value: '01:00 AM', text: '01:00 AM' },
  { value: '01:15 AM', text: '01:15 AM' },
  { value: '01:30 AM', text: '01:30 AM' },
  { value: '01:45 AM', text: '01:45 AM' },
  { value: '02:00 AM', text: '02:00 AM' },
  { value: '02:15 AM', text: '02:15 AM' },
  { value: '02:30 AM', text: '02:30 AM' },
  { value: '02:45 AM', text: '02:45 AM' },
  { value: '03:00 AM', text: '03:00 AM' },
  { value: '03:15 AM', text: '03:15 AM' },
  { value: '03:30 AM', text: '03:30 AM' },
  { value: '03:45 AM', text: '03:45 AM' },
  { value: '04:00 AM', text: '04:00 AM' },
  { value: '04:15 AM', text: '04:15 AM' },
  { value: '04:30 AM', text: '04:30 AM' },
  { value: '04:45 AM', text: '04:45 AM' },
  { value: '05:00 AM', text: '05:00 AM' },
  { value: '05:15 AM', text: '05:15 AM' },
  { value: '05:30 AM', text: '05:30 AM' },
  { value: '05:45 AM', text: '05:45 AM' },
  { value: '06:00 AM', text: '06:00 AM' },
  { value: '06:15 AM', text: '06:15 AM' },
  { value: '06:30 AM', text: '06:30 AM' },
  { value: '06:45 AM', text: '06:45 AM' },
  { value: '07:00 AM', text: '07:00 AM' },
  { value: '07:15 AM', text: '07:15 AM' },
  { value: '07:30 AM', text: '07:30 AM' },
  { value: '07:45 AM', text: '07:45 AM' },
  { value: '08:00 AM', text: '08:00 AM' },
  { value: '08:15 AM', text: '08:15 AM' },
  { value: '08:30 AM', text: '08:30 AM' },
  { value: '08:45 AM', text: '08:45 AM' },
  { value: '09:00 AM', text: '09:00 AM' },
  { value: '09:15 AM', text: '09:15 AM' },
  { value: '09:30 AM', text: '09:30 AM' },
  { value: '09:45 AM', text: '09:45 AM' },
  { value: '10:00 AM', text: '10:00 AM' },
  { value: '10:15 AM', text: '10:15 AM' },
  { value: '10:30 AM', text: '10:30 AM' },
  { value: '10:45 AM', text: '10:45 AM' },
  { value: '11:00 AM', text: '11:00 AM' },
  { value: '11:15 AM', text: '11:15 AM' },
  { value: '11:30 AM', text: '11:30 AM' },
  { value: '11:45 AM', text: '11:45 AM' },
  { value: '12:00 PM', text: '12:00 PM' },
  { value: '12:15 PM', text: '12:15 PM' },
  { value: '12:30 PM', text: '12:30 PM' },
  { value: '12:45 PM', text: '12:45 PM' },
  { value: '01:00 PM', text: '01:00 PM' },
  { value: '01:15 PM', text: '01:15 PM' },
  { value: '01:30 PM', text: '01:30 PM' },
  { value: '01:45 PM', text: '01:45 PM' },
  { value: '02:00 PM', text: '02:00 PM' },
  { value: '02:15 PM', text: '02:15 PM' },
  { value: '02:30 PM', text: '02:30 PM' },
  { value: '02:45 PM', text: '02:45 PM' },
  { value: '03:00 PM', text: '03:00 PM' },
  { value: '03:15 PM', text: '03:15 PM' },
  { value: '03:30 PM', text: '03:30 PM' },
  { value: '03:45 PM', text: '03:45 PM' },
  { value: '04:00 PM', text: '04:00 PM' },
  { value: '04:15 PM', text: '04:15 PM' },
  { value: '04:30 PM', text: '04:30 PM' },
  { value: '04:45 PM', text: '04:45 PM' },
  { value: '05:00 PM', text: '05:00 PM' },
  { value: '05:15 PM', text: '05:15 PM' },
  { value: '05:30 PM', text: '05:30 PM' },
  { value: '05:45 PM', text: '05:45 PM' },
  { value: '06:00 PM', text: '06:00 PM' },
  { value: '06:15 PM', text: '06:15 PM' },
  { value: '06:30 PM', text: '06:30 PM' },
  { value: '06:45 PM', text: '06:45 PM' },
  { value: '07:00 PM', text: '07:00 PM' },
  { value: '07:15 PM', text: '07:15 PM' },
  { value: '07:30 PM', text: '07:30 PM' },
  { value: '07:45 PM', text: '07:45 PM' },
  { value: '08:00 PM', text: '08:00 PM' },
  { value: '08:15 PM', text: '08:15 PM' },
  { value: '08:30 PM', text: '08:30 PM' },
  { value: '08:45 PM', text: '08:45 PM' },
  { value: '09:00 PM', text: '09:00 PM' },
  { value: '09:15 PM', text: '09:15 PM' },
  { value: '09:30 PM', text: '09:30 PM' },
  { value: '09:45 PM', text: '09:45 PM' },
  { value: '10:00 PM', text: '10:00 PM' },
  { value: '10:15 PM', text: '10:15 PM' },
  { value: '10:30 PM', text: '10:30 PM' },
  { value: '10:45 PM', text: '10:45 PM' },
  { value: '11:00 PM', text: '11:00 PM' },
  { value: '11:15 PM', text: '11:15 PM' },
  { value: '11:30 PM', text: '11:30 PM' },
  { value: '11:45 PM', text: '11:45 PM' },
  { value: '11:59:59 PM', text: '12:00 AM' },
];

export const serviceOfferingAvailabilityTemplate = {
  id: 0,
  fromTime: '12:00 AM',
  toTime: '11:59:59 PM',
  isMondaySelected: false,
  isTuesdaySelected: false,
  isWednesdaySelected: false,
  isThursdaySelected: false,
  isFridaySelected: false,
  isSaturdaySelected: false,
  isSundaySelected: false,
};

export function fetchInTimeOptionStart(option) {
  return timeOptionStart.find((x) => x.value == option).text;
}

export function fetchInTimeOptionEnd(option) {
  return timeOptionEnd.find((x) => x.value == option).text;
}

export function getTimeOptionEnd(startValue) {
  if (!startValue) {
    return timeOptionEnd;
  }
  var Index = timeOptionEnd.findIndex((x) => x.value == startValue);
  if (Index < 0) {
    return timeOptionEnd;
  }
  return timeOptionEnd.slice(Index + 1, timeOptionEnd.length);
}

export function verifyIfDaySelectionCorrect(options) {
  let correctOperatingHours = options.filter((x) => {
    return (
      x.isMondaySelected ||
      x.isTuesdaySelected ||
      x.isWednesdaySelected ||
      x.isThursdaySelected ||
      x.isFridaySelected ||
      x.isSaturdaySelected ||
      x.isSundaySelected
    );
  });
  return correctOperatingHours.length > 0;
}
